import { render, staticRenderFns } from "./LinsesDescriptionBlock.vue?vue&type=template&id=5f65990e&scoped=true&"
import script from "./LinsesDescriptionBlock.vue?vue&type=script&lang=js&"
export * from "./LinsesDescriptionBlock.vue?vue&type=script&lang=js&"
import style0 from "./LinsesDescriptionBlock.vue?vue&type=style&index=0&id=5f65990e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f65990e",
  null
  
)

export default component.exports